/** @format */
import { AxiosRequestConfig } from 'axios';

import { MarketCode } from '@toucan/config/markets';

import { client } from '@toucan/services/request-client';
import { transformTransactionSummary } from '@toucan/services/requests/checkout';

import { TransactionVariant } from '../config/constants';
import { TransactionByCustomerResponse } from '../config/types/customer';
import { QuoteExpiryState } from '../config/types/quote';
import { transformExpiredQuotes } from '../helpers/quotes';

/**
 * Gets a list of open quotes
 */
export const getOpenQuotes = async (
    market: MarketCode,
    customerId: number,
    length: number,
    start: number
): Promise<TransactionByCustomerResponse> => {
    const request = {
        customerId,
        length,
        start,
        quoteExpiry: QuoteExpiryState.UNEXPIRED,
        hasActiveCollectionConsignment: false,
        variant: [
            TransactionVariant.PART_EXCHANGE,
            TransactionVariant.CASH_PURCHASE,
        ],
    };

    const config: AxiosRequestConfig = {
        headers: {
            'X-Market': market.toLowerCase(),
        },
    };

    const response = await client.post(
        '/transaction-service/v2/transaction-by-customer/',
        request,
        config
    );

    response.data.data = response.data.data.map((transaction: any) =>
        transformTransactionSummary(transaction, [])
    );
    return response.data;
};

/**
 * Gets a list of expired quotes
 */
export const getExpiredQuotes = async (
    market: MarketCode,
    customerId: number,
    length: number,
    start: number
): Promise<TransactionByCustomerResponse> => {
    const request = {
        customerId,
        length,
        start,
        quoteExpiry: QuoteExpiryState.EXPIRED,
        hasActiveCollectionConsignment: false,
        variant: [
            TransactionVariant.PART_EXCHANGE,
            TransactionVariant.CASH_PURCHASE,
        ],
    };

    const config: AxiosRequestConfig = {
        headers: {
            'X-Market': market.toLowerCase(),
        },
    };

    const response = await client.post(
        '/transaction-service/v2/transaction-by-customer/',
        request,
        config
    );

    response.data.data = response.data.data.map((transaction: any) =>
        transformExpiredQuotes(transformTransactionSummary(transaction, []))
    );
    return response.data;
};

export const getTransactions = async (
    market: MarketCode,
    customerId: number,
    length: number,
    start: number
): Promise<TransactionByCustomerResponse> => {
    const request = {
        customerId,
        length,
        start,
        hasActiveCollectionConsignment: true,
        ignoreDeclinedOrCancelled: false,
        ignoreCancelledTransactions: true,
        variant: [
            TransactionVariant.PART_EXCHANGE,
            TransactionVariant.CASH_PURCHASE,
            TransactionVariant.ORDER,
        ],
    };

    const config: AxiosRequestConfig = {
        headers: {
            'X-Market': market.toLowerCase(),
        },
    };

    const response = await client.post(
        '/transaction-service/v2/transaction-by-customer/',
        request,
        config
    );

    response.data.data = response.data.data.map((transaction: any) =>
        transformTransactionSummary(transaction)
    );
    return response.data;
};
